import { SubscriptionTier } from "~/queries/subscription";

enum ProjectTemplate {
    DAILY_PROGRESS = "DAILY_PROGRESS"
}

const getTemplateLabel = (templateType: ProjectTemplate) => {
    const templateNameMap: Record<ProjectTemplate, string> = {
        DAILY_PROGRESS: "Daily Progress",
    };

    return templateNameMap[templateType];
};

const getTemplateImage = (templateType: ProjectTemplate) => {
    const templateImageMap: Record<ProjectTemplate, string> = {
        DAILY_PROGRESS: '/images/daily-progress.png',
    };

    return templateImageMap[templateType];
};

export enum ProjectSource {
    FIGMA = "FIGMA",
    LINEAR = "LINEAR"
}

export const INTEGRATION_ICONS = {
    FIGMA: '/icons/figma-icon.svg',
    LINEAR: '/icons/linear-icon.svg',
} as const;

enum ConnectionStatus {
    CONNECTED = "CONNECTED",
    ERROR = "ERROR",
    DISCONNECTED = "DISCONNECTED",
    ACCESS_DENIED = "ACCESS_DENIED"
}

export enum DeckVisibility {
    PRIVATE = "PRIVATE",
    PUBLIC = "PUBLIC"
}

export interface CreateProjectRequest {
    name: string;
    template: ProjectTemplate;
    integrations: IntegrationRequest[];
    settings: ProjectSettings;
}

export interface IntegrationRequest {
    source: ProjectSource;
    authToken: string;
    resourcesConfig: string;
}

export interface ProjectSettings {
    storyAutoGenerationEnabled: boolean;
    storyAutoGenerationTime?: string;
}

export interface ProjectIntegration {
    source: ProjectSource;
    connectionStatus: ConnectionStatus;
    resourcesConfig: object;
}

export interface DeckUsageInfo {
    currentTier: SubscriptionTier;
    currentDeckCount: number;
    deckLimit: number;
}

export interface ProjectUsageInfo {
    currentTier: SubscriptionTier;
    currentProjectCount: number;
    projectLimit: number; //TODO might have to change to number | null (API is Integer)
}

export interface ProjectResponse {
    id: string;
    name: string;
    template: ProjectTemplate;
    integrations: ProjectIntegration[];
    settings: ProjectSettings;
    deckUsageInfo: DeckUsageInfo;
    deletionScheduledAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface UserProjects {
    projects: ProjectResponse[];
    projectUsageInfo: ProjectUsageInfo;
}

export interface DeckTimelineItem {
    id: string;
    title: string;
    conversationId: string;
    createdAt: string;
    visibility: DeckVisibility;
    thumbnailUrl?: string;
    outlineCanvasId?: string;
    /** 'deckgen' = client-side structured DeckGen deck; absent/'tldraw' = backend Story deck. */
    kind?: 'tldraw' | 'deckgen';
}

export interface DeckGenerationState {
    isGenerating: boolean;
    message: string | null;
    currentStep: number;
    totalSteps: number;
    error: string | null;
}

export interface DeckTimelineGroup {
    date: string;
    deckItem: DeckTimelineItem;
}

export interface ConversationTimelineItem {
    conversationId: string;
    title: string;
    currentStage: string;
    createdAt: string;
    updatedAt: string;
    thumbnailUrl?: string;
}

export interface ConversationTimelineGroup {
    date: string;
    conversationItem: ConversationTimelineItem;
}

export interface ProjectDashboard {
    projectId: string;
    timeline: ConversationTimelineGroup[];
}

export interface RenameProjectRequest {
    name: string;
}

export interface UpdateProjectSettingsRequest {
    settings: ProjectSettings;
}
